import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/mep/mep-lookup.constants";
import { MepGetLookupValuesRequest, MepGetLookupValuesResponse } from "../../models/mep/mep.models";

@autoinject()
export class MepLookupService {

    constructor(private requestClient: RequestClientService) {
    }

    public getLookups(request: MepGetLookupValuesRequest) : Promise<MepGetLookupValuesResponse> {
        return this.requestClient.get<MepGetLookupValuesResponse>(`${Urls.GetLookups}`, request);
    }

    public getLookupsByCustomer(request: MepGetLookupValuesRequest) : Promise<MepGetLookupValuesResponse> {
        return this.requestClient.get<MepGetLookupValuesResponse>(`${Urls.GetLookupsByCustomer}`, request);
    }
}